import React from 'react'
import Popup from 'react-popup'
/**
 * Open a delete confirm popup using react-popup
 * showing a message and a Cancel and Ok button.
 *
 * @param {Object} options
 * @property {string} itemName
 * @property {boolean} alert
 * @property {function () : undefined} onConfirm
 * @property {string} [additionalBody]
 */
export function confirmDeletePopup({ itemName, onConfirm, alert, additionalBody }) {
  const bringToFront = true
  const additionalText = additionalBody ? additionalBody : null

  Popup.create(
    {
      title: 'Are you sure?',
      content: (
        <>
          {`Are you sure you want to delete ${itemName}?`}
          {additionalText}
        </>
      ),
      className: 'are-you-sure ' + (alert ? 'alert' : ''),
      buttons: {
        left: [
          {
            text: "No, don't delete",
            className: 'no-btn btn',
            action: Popup.close
          }
        ],
        right: [
          {
            text: 'Yes, delete',
            className: 'yes-btn btn',
            action: () => {
              if (onConfirm) {
                onConfirm()
              }
              Popup.close()
            }
          }
        ]
      }
    },
    bringToFront
  )
}
